export default {
  "test": "Test"
}